import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const postPriceAndStock = ({ queryKey: [endpoint, sku] }) => {
  const params = {
    sku,
  };

  return axiosAuth
    .post(`${ENDPOINT_ROOT}/${endpoint}`, params)
    .then((res) => res);
  // if (
  //   (res.status === NO_CONTENT || res.status === PARTIAL_CONTENT) &&
  //   retry < 3
  // ) {
  //   setTimeout(
  //     () => postPriceAndStock({ queryKey: [endpoint, mainSku] }, retry + 1),
  //     Math.min(2000 * 2 ** retry, MAX_RETRY_DELAY),
  //   );
  // }
};

export default postPriceAndStock;
